import { StylesConfig, SingleValueProps, GroupBase, CSSObjectWithLabel, ControlProps, ValueContainerProps } from 'react-select';

export const selectInputStyle: StylesConfig<{ value: string; label: string }, false, GroupBase<{ value: string; label: string }>> = {
  menuPortal: (base: CSSObjectWithLabel) => ({
    ...base,
    zIndex: 9999,  
  }),
  
  valueContainer: (base: CSSObjectWithLabel, _props: ValueContainerProps<{ value: string; label: string }, false, GroupBase<{ value: string; label: string }>>) => ({
    ...base,
    fontWeight: 400,
    color: "#787878",
    height: '30.76px',
    padding: '0 8px',
  }),
  indicatorsContainer: (base) => ({
    ...base,
    height: '30.76px',
  }),
  input: (base) => ({
    ...base,
    margin: '0px',
    padding: '0px',
    fontSize: '11.5px',
  }),
  singleValue: (base: CSSObjectWithLabel, _props: SingleValueProps<{ value: string; label: string }, false, GroupBase<{ value: string; label: string }>>) => ({
    ...base,
    // fontWeight: 400,
    // color: "#787878",
    lineHeight: '30.76px',
    fontSize: '11.5px',
    color:'#9598a0',
    fontWeight:'400'
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: '11.5px',
    color:'#9598a0',
    fontWeight:'400'
  }),
  control: (base: CSSObjectWithLabel, _props: ControlProps<{ value: string; label: string }, false, GroupBase<{ value: string; label: string }>>) => ({
    ...base,
    // height: 33.8,
    // minHeight: 33.8,
    minHeight: '30.76px',
    height: '30.76px',
    minWidth: 200,
    width: "100%",
    maxWidth: "200px",
    // borderColor: "#e3e3e3",
    borderBlockWidth: "1px",
    borderRightWidth: "1px",
    borderLeftWidth: "1px",
    borderWidth: "0px",
    outlineWidth: "0px",
    boxShadow: "none",
    // borderRadius: "0.2rem",
    // fontSize: "12px",
    marginBottom: "10px",
    borderColor: '#ebedf2',
    borderRadius: '5px',
    fontSize: '10px',
    marginTop:'2px',
    '&:hover': {
      borderColor: '#ebedf2',
    },
  }),
};
